module.exports = __webpack_public_path__ + "img/chewy.a848721e.png";